export enum FinishClipping {
  NO_CLIPPING = "NO_CLIPPING", // default
  CLIP_FINISH = "CLIP_FINISH",
  // CLIP_CASING = "CLIP_CASING", // to be implemented in the future
}
